import NavigationTags from './NavigationTags';

export default {
  name: 'dn-navigation-info',

  props: {
    link: [Object, String],
    tags: {
      type: Boolean,
      // default: true,
    },
  },

  computed: {
    computedLink() {
      let { link } = this;
      if (!link) {
        link = this.$store.getters['navigation/matchedLink'];
      } else if (link === 'latest') {
        const group = this.$store.getters['navigation/matchedGroup'];
        if (!group) return;
        link = group.links.find(l => (l.created && !!l.created.latest));
      }

      return link || null;
    },
  },

  render(h) {
    const link = this.computedLink;
    if (!link) return;

    const children = [];

    if (link.publishState) {
      const publishinfo = link[link.publishState];
      const suffix = link.publishState === 'created' ? '公開' : '更新';
      const time = publishinfo.hours + ':' + String(publishinfo.minutes).padStart(2, '0');
      const label = publishinfo.shortLabel + ' ' + time + ' ' + suffix;
      children.push(h('p', {
        staticClass: 'mdTxtUpdate01 tar mb10',
      }, label));
    }

    if (this.tags && link.tags) {
      children.push(h(NavigationTags, {
        props: {
          lg: true,
          title: 'ジャンル',
          link,
        },
      }));
    }

    if (children.length === 0) return;

    return h('div', {
      staticClass: 'dn-navigation-info',
    }, children);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/NavigationInfo.js